import { convertEWSFolderIdToRestFolderId } from 'owa-favorites';
export function createClientFavoritePersonaData(favoriteId, personaNode, isMigration) {
    return {
        treeType: 'favorites',
        type: 'persona',
        favoriteId: favoriteId,
        displayName: personaNode.displayName,
        searchFolderId: personaNode.searchFolderId,
        client: isMigration ? 'Migration' : 'OWA',
        allEmailAddresses: personaNode.allEmailAddresses,
        personaId: personaNode.personaId,
        mainEmailAddress: personaNode.mainEmailAddress,
        isSearchFolderPopulated: !!personaNode.searchFolderId,
        isSyncUpdateDone: true,
    };
}
/**
 * Create a favorite migration service object by passing all the available info
 */
export function createOwsFavoritePersonaData(personaNode) {
    var singleValueSettings = [];
    if (personaNode.mainEmailAddress) {
        singleValueSettings.push({
            Key: 'MainEmailAddress',
            Value: personaNode.mainEmailAddress,
        });
    }
    if (personaNode.personaId) {
        singleValueSettings.push({
            Key: 'PersonaId',
            Value: convertEWSFolderIdToRestFolderId(personaNode.personaId),
        });
    }
    if (personaNode.searchFolderId) {
        singleValueSettings.push({
            Key: 'SearchFolderId',
            Value: convertEWSFolderIdToRestFolderId(personaNode.searchFolderId),
        });
    }
    return {
        Type: 'persona',
        DisplayName: personaNode.displayName,
        SingleValueSettings: singleValueSettings,
        MultiValueSettings: personaNode.allEmailAddresses
            ? [
                {
                    Key: 'EmailAddresses',
                    Values: personaNode.allEmailAddresses,
                },
            ]
            : [],
        Client: 'Migration',
    };
}
//# sourceMappingURL=favoritePersonaDataHelper.js.map